import moment from 'moment';

export default {
  region: '',
  startDate: moment().subtract(20, 'days'),
  endDate: moment(),
  offset: 0,
  stationActivityData: { results: [] },
  loadingStationActivity: false,
  loadingStationActivityFailed: false,
  loadingStationActivitySucceeded: false,
  loadingStationActivityError: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/stationactivity/state.js